import React from 'react';
import { ShieldCheck, MessageCircle, Lock, Users, BadgeCheck } from 'lucide-react';

const trustPoints = [
  {
    icon: MessageCircle,
    title: 'Secure WhatsApp Delivery',
    description: 'Reports are sent only on your verified WhatsApp number. No public links, no third parties.'
  },
  {
    icon: Lock,
    title: 'End-to-End Encrypted',
    description: 'All conversations are protected by WhatsApp\'s native end-to-end encryption.'
  },
  {
    icon: ShieldCheck,
    title: '100% Privacy Promise',
    description: 'Your birth details are never shared, sold, or used for marketing. Personal stays personal.'
  },
  {
    icon: Users,
    title: '5,000+ Trusted Clients',
    description: 'Verified readings delivered across India and 14+ countries since 2018.'
  }
];

export const TrustSection = () => {
  return (
    <section className="py-20 sm:py-28 bg-[#0A0000] relative">
      {/* Subtle gold border top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

      <div className="container mx-auto px-4 max-w-6xl">
        <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-4 font-light">
          SECURE & TRUSTED
        </p>

        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl text-center text-white mb-3 font-medium">
          Your trust is sacred to us
        </h2>
        <p className="text-center text-[#A89B8C] mb-14 text-sm sm:text-base max-w-2xl mx-auto">
          We treat every birth chart with the same care a temple priest treats a sacred ritual. Quietly, respectfully, and entirely for you.
        </p>

        {/* Trust Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14" data-testid="trust-grid">
          {trustPoints.map((point) => (
            <div
              key={point.title}
              className="bg-black/50 border border-[#D4AF37]/20 rounded-2xl p-6 text-center hover:border-[#D4AF37]/50 transition-colors duration-200"
            >
              <div className="w-14 h-14 mx-auto rounded-full bg-gradient-to-br from-[#D4AF37]/15 to-[#FF9933]/5 border border-[#D4AF37]/30 flex items-center justify-center mb-4">
                <point.icon className="w-6 h-6 text-[#D4AF37]" />
              </div>
              <h3 className="text-base font-medium text-white font-['Cormorant_Garamond'] mb-2">
                {point.title}
              </h3>
              <p className="text-[#A89B8C] text-xs leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust badges row */}
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 pt-8 border-t border-[#D4AF37]/15">
          <div className="flex items-center gap-2 text-[#A89B8C] text-xs">
            <BadgeCheck className="w-4 h-4 text-[#D4AF37]" />
            <span>Verified Astrologer Since 2018</span>
          </div>
          <div className="flex items-center gap-2 text-[#A89B8C] text-xs">
            <ShieldCheck className="w-4 h-4 text-[#D4AF37]" />
            <span>GDPR-style Privacy Policy</span>
          </div>
          <div className="flex items-center gap-2 text-[#A89B8C] text-xs">
            <Lock className="w-4 h-4 text-[#D4AF37]" />
            <span>WhatsApp E2E Encryption</span>
          </div>
          <div className="flex items-center gap-2 text-[#A89B8C] text-xs">
            <Users className="w-4 h-4 text-[#D4AF37]" />
            <span>5,000+ Happy Clients</span>
          </div>
        </div>
      </div>
    </section>
  );
};
